import React from "react";
import {
  Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import LoadingTBody from "components/LoadingTBody";
import { MOVEMENT_STATUS, MOVEMENT_STATUS_CODES } from "utils/Constants";
import PackageCostDetailsOffCanvas from "components/OffCanvas/PackageCostDetailsOffCanvas";
import { getPackageStatus } from "utils/Utils";

const UserPackagesTable = props => {
  const { packages, onPackageEdit, onPackageDelete, isLoading } = props;

  const isPackageInTransitToWareHouse = (box) => {
    return box.cargoMovement ? false : true;
  }

  const renderList = () => {
    return packages && packages.map((box) => {
      return (
        <tr key={box.id}>
          <td>
            <a href="javascript:void(0)" onClick={(e) => { editPackage(box) }}>
              {box.secuencia}
            </a>
          </td>
          <td>
            <a href="javascript:void(0)" onClick={(e) => { editPackage(box) }}>
              {box.tracking_num}
            </a>
          </td>
          <td>
            {box.provedor}
          </td>
          <td>
            {getPackageStatus(box)}
          </td>
          <td>
            <PackageCostDetailsOffCanvas box={box} color="primary" />
          </td>
          <td className={styles.actionColumn}>
            {rowActions(box)}
          </td>
        </tr>
      );
    });
  }

  const isBoxCostCalculated = (box) => {
    return box?.boxCost?.id !== null && box?.boxCost?.id !== undefined;
  }

  const rowActions = (box) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { editPackage(box) }}>
            {isBoxCostCalculated(box) || !isPackageInTransitToWareHouse(box) ? "Ver Paquete" : "Editar Paquete"}
          </DropdownItem>
          {isPackageInTransitToWareHouse(box) &&
            (<DropdownItem onClick={(e) => { showDeleteConfirm(box) }}>
              Eliminar Prealerta
            </DropdownItem>
            )}
        </DropdownMenu>
      </UncontrolledDropdown >
    );
  }

  const showDeleteConfirm = (box) => {
    if (onPackageDelete) {
      onPackageDelete({ ...box });
    }
  }

  const editPackage = (box) => {
    if (onPackageEdit) {
      onPackageEdit({ ...box });
    }
  }

  return (
    <>
      <Table className={styles.packagesTable} responsive hover>
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              Tracking
            </th>
            <th>
              Proveedor
            </th>
            <th>
              Estado
            </th>
            <th>
              Costo
            </th>
            <th width="2%"></th>
          </tr>
        </thead>
        <LoadingTBody isLoading={isLoading}>
          {renderList()}
        </LoadingTBody>
      </Table>
    </>
  );
}

export default UserPackagesTable;
